// Pure decision logic for the browser-navigation unsaved-changes guard
// (EditorApp.jsx: beforeunload + back-navigation dialog). Reuses the exact
// change-detection predicate the opt-in autosave feature already ships —
// see autosaveDecision.es6 — instead of a second "are there unsaved
// changes?" implementation.
import { hasUndoSignatureChanged } from "./autosaveDecision.es6";

// window.top/window.self are readable cross-origin without throwing (unlike
// window.top.location), so this is safe even when the parent is a
// different origin. Accepts an injected window object so it's testable
// without jsdom iframe setup.
export function isStandaloneWindow(win) {
  const w = win || (typeof window !== "undefined" ? window : undefined);
  if (!w) return true;
  return w.self === w.top;
}

// Should the beforeunload/back-navigation guard warn right now? Mirrors
// EditorApp's own autosave gate (no trainingId -> nothing to save to, see
// _autosaveTick) and adds the embedded-iframe gate: a host LMS embeds this
// editor in an iframe and drives its own save/exit via postMessage
// (index.jsx triggerSave/saveAndExit), so hijacking the top-level window's
// unload/history from inside that iframe risks breaking the host's own
// routing — both guards are standalone-only.
export function shouldGuardNavigation({
  trainingId,
  isStandalone,
  lastSavedSignature,
  currentSignature,
}) {
  if (!isStandalone) return false;
  if (trainingId == null || trainingId === "") return false;
  return hasUndoSignatureChanged(lastSavedSignature, currentSignature);
}
